<div class="row mt-3" [formGroup]="form">
  <div class="col-md-12">
    <div class="card">

      <div class="float-start card-header card-header-detail" i18n>Derzeitige Beschäftigung im Aufenthaltsland</div>

      <div class="card-body">

        <div class="row">

          <div class="col-md-4">
            <div class="mb-3">
              <label for="antragsteller.personendaten.berufdaten.berufAuswahl" i18n [class.mandatory]="isMandatory('berufAuswahl')"
              >Derzeitige berufliche Tätigkeit:</label>
              <select id="antragsteller.personendaten.berufdaten.berufAuswahl"
                      class="form-select form-select-sm"
                      [class.is-invalid]="errorClassRequired(form.controls['berufAuswahl'])"
                      formControlName="berufAuswahl"
                      [ngbPopover]="popupBerufAuswahl"
              >
                <option value="" selected></option>
                <option *ngFor="let listItem of berufListItems"
                        value="{{ listItem.key }}">{{ listItem.value }}
                </option>
              </select>
              <ng-template #popupBerufAuswahl>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier die derzeitige berufliche Tätigkeit des/der Antragstellenden ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label for="antragsteller.personendaten.berufdaten.firmenname" i18n [class.mandatory]="isMandatory('firmenname')"
              >Firmenname/Name der Bildungseinrichtung:</label>
              <input id="antragsteller.personendaten.berufdaten.firmenname"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('firmenname')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['firmenname'])"
                     formControlName="firmenname"
                     [ngbPopover]="popupFirmenname"
              >
              <ng-template #popupFirmenname>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier den Namen des Arbeitgebers/der besuchten Bildungseinrichtung des/der Antragstellenden ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-md-4">
            <div class="mb-3">
              <label for="antragsteller.personendaten.berufdaten.strasse" i18n [class.mandatory]="isMandatory('strasse')">Straße:</label>
              <input id="antragsteller.personendaten.berufdaten.strasse"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('strasse')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['strasse'])"
                     formControlName="strasse"
                     [ngbPopover]="popupStrasse"
              >
              <ng-template #popupStrasse>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier die Straße der Anschrift des Arbeitgebers/der besuchten Bildungseinrichtung ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="antragsteller.personendaten.berufdaten.hausnummer" i18n [class.mandatory]="isMandatory('hausnummer')">Hausnummer:</label>
              <input id="antragsteller.personendaten.berufdaten.hausnummer"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('hausnummer')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['hausnummer'])"
                     formControlName="hausnummer"
                     [ngbPopover]="popupHausnummer"
              >
              <ng-template #popupHausnummer>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier die Hausnummer der Anschrift des Arbeitgebers/der besuchten Bildungseinrichtung ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="antragsteller.personendaten.berufdaten.sonstigeAdressangaben" i18n [class.mandatory]="isMandatory('sonstigeAdressangaben')"
              >Sonstige Adressangaben:</label>
              <input id="antragsteller.personendaten.berufdaten.sonstigeAdressangaben"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('sonstigeAdressangaben')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['sonstigeAdressangaben'])"
                     formControlName="sonstigeAdressangaben"
                     [ngbPopover]="popupSonstigeAdressangaben"
              >
              <ng-template #popupSonstigeAdressangaben>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier ggf. zusätzliche Details zur Anschrift der Firma/der besuchten Bildungseinrichtung ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-md-4">
            <div class="mb-3">
              <label for="antragsteller.personendaten.berufdaten.plz" i18n [class.mandatory]="isMandatory('plz')">Postleitzahl:</label>
              <input id="antragsteller.personendaten.berufdaten.plz"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('plz')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['plz'])"
                     formControlName="plz"
                     [ngbPopover]="popupPlz"
              >
              <ng-template #popupPlz>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier die Postleitzahl der Anschrift des Arbeitgebers/der besuchten Bildungseinrichtung ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="antragsteller.personendaten.berufdaten.ort" i18n [class.mandatory]="isMandatory('ort')">Ort:</label>
              <input id="antragsteller.personendaten.berufdaten.ort"
                     type="text"
                     appToUpperCase
                     [attr.maxlength]="getMaxLength('ort')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['ort'])"
                     formControlName="ort"
                     [ngbPopover]="popupOrt"
              >
              <ng-template #popupOrt>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier den Ort der Anschrift des Arbeitgebers/der besuchten Bildungseinrichtung ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>

          <div class="col-md-4">
            <div class="mb-3">
              <label for="antragsteller.personendaten.berufdaten.land" i18n [class.mandatory]="isMandatory('land')">Land:</label>
              <select id="antragsteller.personendaten.berufdaten.land"
                      class="form-select form-select-sm"
                      [class.is-invalid]="errorClassRequired(form.controls['land'])"
                      formControlName="land"
                      [ngbPopover]="popupLand"
              >
                <option value="" selected></option>
                <option *ngFor="let listItem of landListItems"
                        value="{{ listItem.key }}">{{ listItem.value }}
                </option>
              </select>
              <ng-template #popupLand>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier das Land der Anschrift des Arbeitgebers/der besuchten Bildungseinrichtung ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-4">
            <label for="antragsteller.personendaten.berufdaten.firmenTelefonNr" i18n [class.mandatory]="isMandatory('firmenTelefonNr')"
            >Telefon-/Mobilfunknummer:</label>
            <input id="antragsteller.personendaten.berufdaten.firmenTelefonNr"
                   type="text"
                   appToUpperCase
                   [attr.maxlength]="getMaxLength('firmenTelefonNr')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['firmenTelefonNr'])"
                   formControlName="firmenTelefonNr"
                   [ngbPopover]="popupFirmenTelefonNr"
            >
            <ng-template #popupFirmenTelefonNr>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier die aktuelle Telefonnummer des Arbeitgebers/der besuchten Bildungseinrichtung des/der Antragstellenden ein.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
